import { getVariantColumns } from './categories/variantColumns';
import { getGeneColumns } from './categories/geneColumns';
import { getDiseaseColumns } from './categories/diseaseColumns';
import { getChemicalColumns } from './categories/chemicalColumns';
import { getAssociationColumns } from './categories/associationColumns';
import { getDDAColumns } from './categories/ddaColumns';
import { getMetricsColumns } from './categories/metricsColumns';
import { ColumnDefinition } from './shared/column-types';
import { searchContext, userAppContext } from '../../../context/Context';
import { ColumnContext } from '../types';

/**
 * Función principal que retorna todas las columnas según el contexto actual
 * Esta función reemplaza la función Columns() del archivo original
 */
export function getAllColumns(options?: { isEvidence?: boolean }): ColumnDefinition[] {
  const { tab } = searchContext();
  const { groups, isAuthenticated } = userAppContext();
  const isEvidence = options?.isEvidence ?? false;

  const isTrial = groups?.includes('ROLE_TRIAL');
  const isAcademic = groups?.includes('ROLE_ACADEMIC');
  const isGDA = tab === 'GDA';
  const isVDA = tab === 'VDA';

  // Contexto compartido para todas las funciones de columnas
  const context: ColumnContext = {
    tab,
    groups,
    isAuthenticated,
    isTrial,
    isAcademic,
    isGDA,
    isVDA,
    isEvidence,
  };

  // Combina todas las columnas de las diferentes categorías
  return [
    ...getVariantColumns(context),
    ...getGeneColumns(context),
    ...getDiseaseColumns(context),
    ...getChemicalColumns({ tab, isGDA, isVDA, isAcademic, isAuthenticated }),
    ...getAssociationColumns(context),
    ...getDDAColumns(context),
    ...getMetricsColumns(context),
  ];
}

// Re-exporta los componentes necesarios
export { ButtonInfoGeneContent } from './components';
